module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"Welcome to Verification System!"},"ja":{"hello":"手続きシステムへようこそ！"}}')
  delete Component.options._Ctor
}
